export default {
  id: 23,
  title: 'Target #23 - Boxception',
  url: 'https://cssbattle.dev/play/23',
  colors: ['#F3AC3C', '#1A4341', '#998235'],
  solution:
    '<a a><a b><a c><style>body{background:#f3ac3c}a{position:fixed}a[a]{top:50;left:100;background:#1a4341;width:200;height:200}a[b]{top:150;left:100;background:#998235;width:100;height:100}a[c]{top:200;left:150;background:#f3ac3c;width:50;height:50}</style>',
}
